export default __webpack_public_path__ + "static/media/coffee.31ded55c.svg";